import React from 'react';
import { Box, Typography, Paper, TextField, Button } from '@mui/material';

function ContactPage() {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Contact Us</Typography>
      <Typography variant="body1" paragraph>
        Have questions or feedback? We'd love to hear from you. Please fill out the form below and we will get back to you as soon as possible.
      </Typography>
      <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
        <TextField fullWidth label="Your Name" margin="normal" />
        <TextField fullWidth label="Your Email" type="email" margin="normal" />
        <TextField fullWidth label="Message" multiline rows={4} margin="normal" />
        <Button variant="contained" sx={{ mt: 2 }}>Send Message</Button>
      </Box>
    </Paper>
  );
}

export default ContactPage;